import api from '~/services/api';
import { LojaProps } from '../protocols/LojaProps';
import { toNumberOrZero } from '~/utils/functions';

export default async function getLoja(
  cod_loja: number,
): Promise<LojaProps | undefined> {
  const { data } = await api.get(`/lojas/${cod_loja}`);

  let props: LojaProps | undefined;

  if (data.success) {
    props = {
      cod_loja: data.data.cod_loja,
      des_loja: data.data.des_loja,
      label:
        data.data.cod_loja < 10
          ? `0${data.data.cod_loja} - ${data.data.des_loja} (${data.data.des_cidade})`
          : `${data.data.cod_loja} - ${data.data.des_loja} (${data.data.des_cidade})`,
      selected: true,
      uf: data.data.des_uf,
      value: data.data.cod_loja,
      num_cnpj: data.data.num_cnpj,
      cod_cidade: data.data.cod_cidade,
      empresa: {
        flg_envia_ibs_cbs: data.data?.flg_envia_ibs_cbs || false,
        per_cbs_teste: toNumberOrZero(data.data?.per_cbs_teste),
        per_ibs_mun_teste: toNumberOrZero(data.data?.per_ibs_mun_teste),
        per_ibs_uf_teste: toNumberOrZero(data.data?.per_ibs_uf_teste),
      },
    };
  }
  return props;
}
